import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Grid from '@magalu/stereo-ui/atoms/Grid';
export var Box = styled(Grid)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));